import { useCallback, useEffect, useRef } from 'react';

export function useAudioCache() {
  const cacheRef = useRef(new Map());

  useEffect(() => {
    const cache = cacheRef.current;
    return () => {
      cache.forEach((audio) => {
        try {
          audio.pause();
        } catch (err) {
          // no-op
        }
      });
      cache.clear();
    };
  }, []);

  const get = useCallback((key) => {
    if (!key) return null;
    return cacheRef.current.get(key) || null;
  }, []);

  const set = useCallback((key, audio) => {
    if (!key || !audio) return;
    cacheRef.current.set(key, audio);
  }, []);

  const has = useCallback((key) => {
    if (!key) return false;
    return cacheRef.current.has(key);
  }, []);

  const remove = useCallback((key) => {
    if (!key) return;
    const audio = cacheRef.current.get(key);
    if (audio) {
      try {
        audio.pause();
        audio.currentTime = 0;
      } catch (err) {
        // no-op
      }
    }
    cacheRef.current.delete(key);
  }, []);

  return {
    get,
    set,
    has,
    remove
  };
}
